import { IconBarChartAxisUp, IconRefreshCcw } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

export const PostRepaymentFreePeriodExplainer = () => {
    return (
        <div className="space-y-s rounded-s bg-secondary-95 p-l">
            <h4 className="my-0 text-l font-bold">
                <FormattedMessage
                    id="_.rcf_approved_view.repayment_schedule_post_repayment_free_period_title"
                    defaultMessage="Your choice in month 12"
                />
            </h4>
            <div className="flex flex-row items-start gap-s text-m">
                <IconRefreshCcw className="mt-xs shrink-0" />
                <Text data-testid="post-repayment-free-period-explainer-description-1">
                    <FormattedMessage
                        id="_.rcf_approved_view.repayment_schedule_post_repayment_free_period_description_1"
                        defaultMessage="<span>Remain flexible:</span> Extend the repayment-free period by another 12 months (subject to credit assessment)."
                        values={{
                            span: (chunks) => (
                                <span className="font-bold">{chunks}</span>
                            )
                        }}
                    />
                </Text>
            </div>
            <div className="flex flex-row items-start gap-s text-m">
                <IconBarChartAxisUp className="mt-xs shrink-0" />
                <Text data-testid="post-repayment-free-period-explainer-description-2">
                    <FormattedMessage
                        id="_.rcf_approved_view.repayment_schedule_post_repayment_free_period_description_2"
                        defaultMessage="<span>Repay as planned:</span> You will pay off the outstanding loan amount over a 12-month repayment phase."
                        values={{
                            span: (chunks) => (
                                <span className="font-bold">{chunks}</span>
                            )
                        }}
                    />
                </Text>
            </div>
        </div>
    );
};
